export default __webpack_public_path__ + "static/media/el5.ae944567.svg";